const html = require("./html/additionalServicesView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import ServiceStore from "../../../stores/CmrServiceStore";
import DomainStore from "../../../stores/CmrDomainStore";
import {toCurrency} from "../../../utilities/currency";
import ServiceView from "./ServiceView";

const elementsMap = {
  additionalServices: ".additional-services-target",
  noServicesAdded: ".no-services-added"
}

export default function AdditionalServicesView(_unused,
  {
    onRemoveServiceRow,
    getRelaventServices,
    getDomains,
    getServices,
    onAddService,
    getAggregateCurrencyTotalViaCurrencyPerUnits,
    shouldShowServiceCloseBtn,
    shouldShowCurrencyPerUnits,
    readOnly
  }
  ){
  const self = this;
  self._element = $();
  const els = {};
  let serviceViews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    // if there are services,
    // always just render the services
    const hasServices = getServices().length;
    if(hasServices){
      serviceViews = renderServices();
      els.additionalServices.html(extractElements(serviceViews));
    }
    handleDisplayFor(els.noServicesAdded, (!hasServices));
  }

  self.unbindListeners = function(){
  }

  function bindElements(){
  }

  function onAddServiceChanged(){
  }

  function updateValues(){
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindElements();
  }

  function renderServices(){
    return _(getServices()).map((service, rowIdx)=>{
      const serviceView = new ServiceView(service, {
        getAggregateCurrencyTotalViaCurrencyPerUnits,
        shouldShowServiceCloseBtn,
        shouldShowCurrencyPerUnits,
        onRemoveServiceRow,
        readOnly
      });
      serviceView.init();
      return serviceView;
    });
  }

  function getServiceSelectDataArray(){
    return _(getDomains()).map((domain)=>{
      return {id: domain.id.toString(), text: domainToSelectOptionText(domain)};
    });
  }

  function domainToSelectOptionText(domain){
    return `${domain.cdm_meaning} (${CmrDomainStore.currencyToHtml(domain)})`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/AdditionalServicesView.js